const ITEMS = [
  "Towards Sustainability",
  "Coastal Numerical Modelling",
  "Marine Environmental Assessment",
  "Metocean Study",
  "Field Surveys",
  "Geo-Spatial Intelligence",
];

export default function Marquee() {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div
      className="relative overflow-hidden border-y border-white/10 py-12 md:py-16"
      data-testid="editorial-marquee"
      aria-hidden="true"
    >
      <div className="marquee-track flex w-max items-center">
        {row.map((item, i) => (
          <span key={i} className="flex items-center gap-10 pr-10">
            <span className="whitespace-nowrap font-editorial text-4xl italic leading-none text-[#f58220] md:text-6xl">
              {item}
            </span>
            <img
              src="/okeanos-mark.png"
              alt=""
              className="h-10 w-auto md:h-14"
            />
          </span>
        ))}
      </div>
    </div>
  );
}
